<template>
  <main id="machine-sheet-capacity">
    <div class="capacity" v-if="displayContent">

      <div class="tabs-container">
        <div class="switcher">
          <a class="switcher-tab" @click="switchTab('truck_data')" :class="{'selected': selectedTab === 'truck_data'}">{{
              $t("truck_data")
            }}</a>
          <a class="switcher-tab" @click="switchTab('results')"
             :class="{'selected': selectedTab === 'results', 'disabled': capacityData.length === 0}">{{
              $t("results")
            }}</a>
        </div>
        <div class="filter-tab" v-if="selectedTab === 'truck_data' || !isMobile">

          <!--Machine-->
          <div class="machines">

            <b-collapse
                aria-id="contentIdForA11y2"
                class="panel"
                animation="slide"
                v-model="machineIsOpen">
              <template #trigger>
                <div
                    class="panel-heading"
                    role="button"
                    aria-controls="contentIdForA11y2"
                    :aria-expanded="isOpen">
                  <h2 class="title is-2">{{ $t('machine') }}<span class="title-arrow"><i
                      class="fa" :class="{'fa-angle-up': machineIsOpen,'fa-angle-down' : !machineIsOpen }"></i></span>
                  </h2>
                </div>
              </template>
              <div class="panel-block">
                <div class="label-item">
                  <div class="the-label">
                    <div class="label-text">
                      {{ $t('capacity_nominal_capacity') }}
                    </div>
                  </div>
                  <span class="dots"></span>
                  <span class="value">{{ parseInt(result.machine.nominal_capacity) }} {{ result.unit[unitType].weight }}</span>
                </div>

                <div class="label-item">
                  <div class="the-label">
                    <div class="label-text">
                      {{ $t('capacity_gravity_center') }}
                    </div>
                  </div>
                  <span class="dots"></span>
                  <span class="value">{{ parseInt(result.machine.gravity_center) }} {{ result.unit[unitType].distance }}</span>
                </div>


                <div class="label-item" v-if="productDatas.values.number_of_front_wheels">
                  <div class="the-label">
                    <div class="label-text">
                      {{ $t('front_tires') }}
                    </div>
                  </div>
                  <span class="dots"></span>
                  <span class="value">{{ productDatas.values.number_of_front_wheels.label }}</span>
                </div>

                <div class="label-item" v-if="productDatas.values.tyre_equipment_bandage_V_PPS_SE_inflatable_tyre_L">
                  <div class="the-label">
                    <div class="label-text">
                      {{ $t('type_of_tires') }}
                    </div>
                  </div>
                  <span class="dots"></span>
                  <span class="value">{{ productDatas.values.tyre_equipment_bandage_V_PPS_SE_inflatable_tyre_L.label }}</span>
                </div>

                <!--                <div class="select-container pneumatics">-->
                <!--                  <h4 class="colored-label">{{ $t('front_tires') }}</h4>-->
                <!--                  <b-field>-->
                <!--                    <b-select :placeholder="$t('select')" rounded expanded class="custom-select">-->
                <!--                      <option-->
                <!--                          v-for="value in productDatas.values.number_of_front_wheels"-->
                <!--                          :value="value"-->
                <!--                          :key="value.code"-->
                <!--                      >{{ value.label }}-->
                <!--                      </option>-->
                <!--                    </b-select>-->
                <!--                  </b-field>-->
                <!--                  <h4 class="colored-label">{{ $t('type_of_tires') }}</h4>-->
                <!--                  <b-field>-->
                <!--                    <b-select :placeholder="$t('select')" rounded expanded class="custom-select">-->
                <!--                      <option value=""></option>-->
                <!--                    </b-select>-->
                <!--                  </b-field>-->
                <!--                </div>-->

              </div>
            </b-collapse>

            <hr class="group-separator"/>
          </div>

          <!--Types de mât-->

          <div class="mats">
            <b-collapse
                aria-id="contentIdForA11y2"
                class="panel"
                animation="slide"
                v-model="matIsOpen">
              <template #trigger>
                <div
                    class="panel-heading"
                    role="button"
                    aria-controls="contentIdForA11y2"
                    :aria-expanded="isOpen">
                  <h2 class="title is-2">{{ $t('mat') }}<span class="title-arrow"><i
                      class="fa" :class="{'fa-angle-up': matIsOpen,'fa-angle-down' : !matIsOpen }"></i></span>
                  </h2>
                </div>
              </template>
              <div class="panel-block">
                <div class="select-container" >
                  <b-field :label="$t('mat_type')" custom-class="colored-label">
                    <b-select v-model="matType" size="is-large" rounded
                              @change.native="fetchCapacityData(missingFields); sendAnalyticsEvent();"
                              :placeholder="$t('enter_mat_type')"
                              :data-v-step="'capacity-mast'">
                      <option
                          v-for="option in productDatas.variants"
                          :value="option"
                          :key="option.identifier"
                      >{{ option.name }}
                      </option>
                    </b-select>
                  </b-field>
                </div>

                <div v-if="matType" class="filter-tab-product">
                  <div class="panel-block">
                    <div class="attributes">
                      <ul>
                        <li v-for="key in Object.keys(engineAttributes)">
                          <div v-if="visibleAttributes.includes(key)" class="label-item">
                            <div class="the-label">
                              <div class="label-text">
                                {{ $t(`capacity_${key}`) }}
                              </div>
                            </div>
                            <span class="dots"></span>
                            <span class="value">{{ Math.round(engineAttributes[key]) }} {{ getUnit(key)}}</span>
                          </div>
                        </li>
                      </ul>
                      <div class="missing-fields" v-if="missingEngineFields.length > 0">
                        <b-field v-for="(missingField, index) in missingEngineFields" :key="missingField.code+index"
                                 :label="$t(`capacity_${missingField.code}`) + ` *` + ' ('+getUnit(missingField.code)+')'" custom-class="colored-label">
                          <b-input v-model="missingEngineFields[index].value" :name="missingField.code" size="is-large"
                                   rounded @change.native="" :placeholder="$t(`enter_capacity_${missingField.code}`)"
                                   type="number" required/>
                        </b-field>
                      </div>
                      <div class="missing-optionnal" v-if="optionnalEngineFields.length > 0">
                        <b-field v-for="(missingField, index) in optionnalEngineFields"
                                 :key="'optionnal'+missingField.code+index" :label="$t(`capacity_${missingField.code}`) + ' ('+getUnit(missingField.code)+')'"
                                 custom-class="colored-label">
                          <b-input v-model="optionnalEngineFields[index].value" :name="missingField.code"
                                   size="is-large"
                                   rounded @change.native="" :placeholder="$t(`enter_capacity_${missingField.code}`)"/>
                        </b-field>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-collapse>

            <hr class="group-separator"/>
          </div>

          <!--Accessoire-->

          <div class="accessories">
            <b-collapse
                aria-id="contentIdForA11y2"
                class="panel"
                animation="slide"
                v-model="accessoryIsOpen">
              <template #trigger>
                <div
                    class="panel-heading"
                    role="button"
                    aria-controls="contentIdForA11y2"
                    :aria-expanded="isOpen">
                  <h2 class="title is-2">{{ $t('accessory') }}<span class="title-arrow"><i
                      class="fa"
                      :class="{'fa-angle-up': accessoryIsOpen,'fa-angle-down' : !accessoryIsOpen }"></i></span>
                  </h2>
                </div>
              </template>
              <div class="panel-block">
                <div class="select-container">
                  <div class="filter-tab-attachment">
                    <div class="product-accessory">
                      <div class="accessory-select">
                        <b-field :label="$t(`accessory`)" custom-class="colored-label">
                          <b-input v-model="accessory" name="accessory"
                                   size="is-large"
                                   rounded @change.native=""
                                   :placeholder="$t(`enter_accessory`)"
                                   type="text"/>
                        </b-field>
                        <b-field :label="$t(`brand`)" custom-class="colored-label">
                          <b-input v-model="accessoryBrand" name="accessory_brand"
                                   size="is-large"
                                   rounded @change.native=""
                                   :placeholder="$t(`enter_accessory_brand`)"
                                   type="text"/>
                        </b-field>
                        <div class="missing-fields" v-if="missingAttachmentFields.length > 0">
                          <b-field v-for="(missingField, index) in missingAttachmentFields"
                                   :label="$t(`capacity_${missingField.code}`) + ' ('+getUnit(missingField.code)+')'" custom-class="colored-label"
                                   :key="`field_${index}`">
                            <b-input v-model="attachmentAttributes[missingField.code]" :name="missingField.code"
                                     size="is-large"
                                     rounded @change.native=""
                                     :placeholder="$t(`enter_capacity_${missingField.code}`)"
                                     type="number"/>
                          </b-field>
                        </div>
                        <div class="missing-optionnal" v-if="optionnalAttachmentFields.length > 0">
                          <b-field v-for="(missingField, index) in optionnalAttachmentFields"
                                   :label="$t(`capacity_${missingField.code}`) + ' ('+getUnit(missingField.code)+')'" custom-class="colored-label"
                                   :key="`field_optionnal_${index}`">
                            <b-input v-model="attachmentAttributes[missingField.code]" :name="missingField.code"
                                     size="is-large" rounded @change.native=""
                                     :placeholder="$t(`enter_capacity_${missingField.code}`)"/>
                          </b-field>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </b-collapse>

            <hr class="group-separator"/>
          </div>

          <!--Fourches-->

          <div class="fourches">

            <b-collapse
                aria-id="contentIdForA11y2"
                class="panel"
                animation="slide"
                v-model="fourcheIsOpen">
              <template #trigger>
                <div
                    class="panel-heading"
                    role="button"
                    aria-controls="contentIdForA11y2"
                    :aria-expanded="isOpen">
                  <h2 class="title is-2">{{ $t('forks') }}<span class="title-arrow"><i
                      class="fa" :class="{'fa-angle-up': fourcheIsOpen,'fa-angle-down' : !fourcheIsOpen }"></i></span>
                  </h2>
                </div>
              </template>
              <div class="panel-block">
                <div class="select-container">
                  <div class="filter-tab-fork">
                    <div class="product-fork">
                      <div class="fork-select">
                        <b-field :label="$t(`fork_name`)" custom-class="colored-label">
                          <b-input v-model="selectedFork" name="fork_name"
                                   size="is-large"
                                   rounded @change.native=""
                                   :placeholder="$t(`enter_fork_name`)"
                                   type="text"/>
                        </b-field>
                        <b-field :label="$t(`brand`)" custom-class="colored-label">
                          <b-input v-model="forkBrand" name="fork_brand"
                                   size="is-large"
                                   rounded @change.native=""
                                   :placeholder="$t(`enter_fork_brand`)"
                                   type="text"/>
                        </b-field>
                        <template>
                          <div class="missing-fields" v-if="missingForkFields.length > 0">
                            <b-field v-for="(missingField, index) in missingForkFields"
                                     :label="$t(`capacity_${missingField.code}`) + ' ('+getUnit(missingField.code)+')'" custom-class="colored-label"
                                     :key="`field_${index}`">
                              <b-input v-model="forkAttributes[missingField.code]" :name="missingField.code"
                                       size="is-large"
                                       rounded @change.native=""
                                       :placeholder="$t(`enter_capacity_${missingField.code}`)"
                                       type="number"/>
                            </b-field>
                          </div>
                          <div class="missing-optionnal" v-if="optionnalForkFields.length > 0">
                            <b-field v-for="(missingField, index) in optionnalForkFields"
                                     :label="$t(`capacity_${missingField.code}`) + ' ('+getUnit(missingField.code)+')'" custom-class="colored-label"
                                     :key="`field_optionnal_${index}`">
                              <b-input v-model="forkAttributes[missingField.code]" :name="missingField.code"
                                       size="is-large" rounded @change.native=""
                                       :placeholder="$t(`enter_capacity_${missingField.code}`)"/>
                            </b-field>
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-collapse>

            <hr class="group-separator"/>

          </div>


          <div class="filter-tab-footer">
            <b-button rounded class="is-primary is-uppercase is-background-color-red" icon-left="sync"
                      :disabled="!missingFieldsCompleted" @click="refreshCapacityData()">{{ $t('refresh_data') }}
            </b-button>
          </div>
        </div>

        <!--*************************************************-->
        <!--**************** Bloc de droite *****************-->

        <div class="result-tab" v-if="selectedTab === 'results' || !isMobile">

          <div class="result-title">
            <h2 class="title is-2">{{ $t('results') }}</h2>
            <p class="introduction-text">{{ $t('calculation_informations') }}</p>
            <div v-if="!matType" class="info-select-mat">
              <p class="text-select-mat">
                <b-icon icon="info-circle" icon-pack="icomoon"></b-icon>
                {{ $t('select_mast_result') }}
              </p>
            </div>
          </div>

          <div v-if="matType && result.machine.height_at_max_capacity !== 0" class="buttons has-addons is-centered">
            <button class="button is-primary is-rounded is-uppercase ml-0" :class="brandBackgroundColor"
                    @click="selectModal()">
              <span class="icon-download is-medium is-left-side"></span>
              <span>{{ $t("download_capacity") }}</span>
            </button>

            <!--            <button class="button is-primary is-rounded is-uppercase ml-0 button-share" :class="brandBackgroundColor"-->
            <!--                    @click="selectModal(true)">-->
            <!--              <span class="icon-share is-medium has-text-centered icon-right"></span>-->
            <!--            </button>-->
          </div>


          <div class="result-container" v-if="!matType || (matType && result.machine.height_at_max_capacity !== 0)">
            <h1 class="title is-1">{{ $t("residual_capacities") }}</h1>
            <!--****************************************-->
            <!--**************** HOOPER ****************-->

            <div class="result-slider">
              <div class="capacity-comparison-container">
                <div class="capacity-comparison">
                  <div v-show="!isPhone" class="label-column">
                    <div class="label-column-wrap">
                      <div>
                        <span class="label-text">
                          <label><b>{{ $t('capacity_max_lifting_height') }}</b> ({{ result.unit[unitType].distance }})</label>

                          <strong class="nothing-selected">
                            <template v-if="matType">
                            {{ parseInt(result.machine.max_lifting_height) }}
                          </template>
                          </strong>
                        </span>
                      </div>
                      <div>
                        <span class="label-text">
                          <label><b>{{ $t('capacity_height_at_max_capacity') }}</b> ({{ result.unit[unitType].distance }})</label>

                          <strong class="nothing-selected">
                            <template v-if="matType">
                            {{ parseInt(result.machine.height_at_max_capacity) }}
                          </template>
                          </strong>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="slider-column">
                    <div v-show="!isPhone" class="mobile-slider-controls">
                      <button
                          class="action previous "
                          :class="{available: canGoPrevious()}"
                          :aria-label="$t('previous')"
                          @click.prevent="slidePrev()"
                      ></button>
                      <button
                          class="action next "
                          :class="{available: canGoNext()}"
                          :aria-label="$t('next')"
                          @click.prevent="slideNext()"
                      ></button>
                    </div>
                    <hooper
                        :ref="'capacity_slider'"
                        :current="currentSlide"
                        :itemsToShow="itemToShow"
                        :itemsToSlide="1"
                        :mouseDrag="false"
                        :touchDrag="false"
                        :keysControl="false"
                        :wheelControl="false"
                        @slide="slideChanged($event)"
                        :key="itemToShow"
                    >
                      <slide
                          v-for="(capacity, capacityIndex) in filteredCapacity"
                          :key="capacityIndex">

                        <div class="capacity-slide">
                          <div v-if="matType" class="capacity-slide-box">
                            <p>{{ parseInt(capacity[unitType].medium) }}</p>
                            <p>{{ parseInt(capacity[unitType].high) }}</p>
                          </div>
                          <div v-else class="capacity-slide-box">
                            <p><br></p>
                            <p><br></p>
                          </div>
                        </div>

                        <div :data-v-step="'capacity-gravity'" v-if="capacityIndex === filteredCapacity.length - 1">
                          <b-field v-if="matType" >
                            <b-input :value="capacity[unitType].gravity_center"
                                     :name="'editable-field-'+capacityIndex"
                                     @keyup.native.enter="changeGravityCenter($event, capacityIndex)"
                                     @blur="changeGravityCenter($event, capacityIndex)" ></b-input>
                          </b-field>
                          <b-field v-else>
                            <b-input></b-input>
                          </b-field>
                        </div>
                        <strong v-else>
                          <p v-if="matType">{{ capacity[unitType].gravity_center }}</p>
                          <p v-else><br></p>
                        </strong>
                      </slide>

                      <slide v-if="filteredCapacity.length === 2">
                        <div class="capacity-slide">
                          <div class="capacity-slide-box">
                            <p><br></p>
                            <p><br></p>
                          </div>
                        </div>

                        <template>
                          <b-field v-if="matType" class="gravity-input">
                            <b-input :name="'editable-field-'+2"
                                     @keyup.native.enter="changeGravityCenter($event, 2)"
                                     @blur="changeGravityCenter($event, 2)"></b-input>
                          </b-field>
                          <b-field v-else>
                            <b-input></b-input>
                          </b-field>
                        </template>
                      </slide>
                    </hooper>
                    <div class="hooper-label">
                      <div>
                        <span class="label-text">
                          <label><b>{{ $t('capacity') }}</b> ({{ result.unit[unitType].weight }})</label>
                          <p v-show="isPhone">{{ $t('for_max_height_of') }} {{ parseInt(result.machine.max_lifting_height) }} {{ result.unit[unitType].distance }} </p>
                        </span>
                      </div>
                      <div>
                        <span class="label-text">
                          <label><b>{{ $t('capacity_nominal_capacity')}}</b> ({{ result.unit[unitType].weight }})</label>
                          <p v-show="isPhone">{{ $t('for_capacity_height_at_max_capacity_of') }} {{ parseInt(result.machine.height_at_max_capacity) }} {{ result.unit[unitType].distance }} </p>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <span class="label-text">
                  <label><b>{{ $t('gravity_center')}}</b> ({{ result.unit[unitType].distance }})</label>
                  <b-tooltip :label="$t('capacity_gravity_center_tooltip')"
                             position="is-top">
                    <span class="icon-question-mark"></span>
                  </b-tooltip>
                </span>
              </div>
              <p class="info-tooltip-mobile" v-if="isPhone">
                <span class="icon-question-mark"></span>
                <span>{{ $t('capacity_gravity_center_tooltip') }}</span>
              </p>
            </div>


            <!--  Accessoire sélectionné  -->

            <div class="result-container" v-if="capacityDataAttach.length > 0">
              <h1 class="title is-1">{{ $t("residual_capacities_with_accessory") }}</h1>
              <h3>{{ $t('accessory_name') }} : {{ accessoryBrand}} {{ accessory }}</h3>

              <div class="result-slider">
                <div class="capacity-comparison-container">
                  <div class="capacity-comparison">
                    <div v-show="!isPhone" class="label-column">
                      <div class="label-column-wrap">
                        <div>
                          <span class="label-text">
                            <label><b>{{ $t('max_height') }}</b> ({{ result.unit[unitType].distance }})</label>
                            <strong>{{ parseInt(resultAttach.machine.max_lifting_height) }}</strong>
                          </span>
                        </div>
                        <div>
                          <span class="label-text">
                            <label><b>{{ $t('capacity_height_at_max_capacity') }}</b> ({{ result.unit[unitType].distance }})</label>
                            <strong>{{ parseInt(resultAttach.machine.height_at_max_capacity) }}</strong>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="slider-column attachment-slider">
                      <div v-show="!isPhone" class="mobile-slider-controls">
                        <button
                            class="action previous "
                            :class="{available: canGoPrevious()}"
                            :aria-label="$t('previous')"
                            @click.prevent="slidePrev()"
                        ></button>
                        <button
                            class="action next "
                            :class="{available: canGoNext()}"
                            :aria-label="$t('next')"
                            @click.prevent="slideNext()"
                        ></button>
                      </div>
                      <hooper
                          :ref="'capacity_slider'"
                          :current="currentSlide"
                          :itemsToShow="itemToShow"
                          :itemsToSlide="1"
                          :mouseDrag="false"
                          :touchDrag="false"
                          :keysControl="false"
                          :wheelControl="false"
                          @slide="slideChanged($event)"
                          :key="itemToShow"
                      >
                        <slide
                            v-for="(capacity, capacityIndex) in filteredCapacityAttach"
                            :key="capacityIndex">

                          <div class="capacity-slide">
                            <div class="capacity-slide-box">

                              <p>{{ parseInt(capacity[unitType].medium) }}</p>
                              <p>{{ parseInt(capacity[unitType].high) }}</p>
                            </div>
                          </div>
                          <template v-if="capacityIndex === filteredCapacity.length - 1">
                            <b-field>
                              <b-input :value="capacity[unitType].gravity_center"
                                       :name="'editable-field-'+capacityIndex"
                                       @keyup.native.enter="changeGravityCenter($event, capacityIndex)"
                                       @blur="changeGravityCenter($event, capacityIndex)"></b-input>
                            </b-field>
                          </template>
                          <strong v-else>
                            {{ capacity[unitType].gravity_center }}
                            <!--                          <b-button icon-left="edit"
                                                                v-if="capacity[unitType].gravity_center!=500 && capacity[unitType].gravity_center!=600"
                                                                @click="changeToInput(capacityIndex)"></b-button>-->
                          </strong>
                        </slide>

                        <slide v-if="filteredCapacity.length==2">
                          <div class="capacity-slide">
                            <div class="capacity-slide-box">
                              <p><br></p>
                              <p><br></p>
                            </div>
                          </div>

                          <template>
                            <b-field v-if="matType">
                              <b-input :name="'editable-field-'+2"
                                       @keyup.native.enter="changeGravityCenter($event, 2)"
                                       @blur="changeGravityCenter($event, 2)"></b-input>
                            </b-field>
                            <b-field v-else>
                              <b-input></b-input>
                            </b-field>
                          </template>
                        </slide>
                      </hooper>
                      <div class="hooper-label">
                        <div>
                        <span class="label-text">
                          <label><b>{{ $t('capacity') }}</b> ({{ result.unit[unitType].weight }})</label>
                          <p v-show="isPhone">{{ $t('for_max_height_of') }} {{ parseInt(result.machine.max_lifting_height) }} {{ result.unit[unitType].distance }} </p>
                        </span>
                        </div>
                        <div>
                        <span class="label-text">
                          <label><b>{{ $t('capacity_nominal_capacity')}}</b> ({{ result.unit[unitType].weight }})</label>
                          <p v-show="isPhone">{{ $t('for_capacity_height_at_max_capacity_of') }} {{ parseInt(result.machine.height_at_max_capacity) }} {{ result.unit[unitType].distance }} </p>
                        </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <span class="label-text">
                    <label><b>{{ $t('gravity_center') }}</b> ({{ result.unit[unitType].distance }})</label>
                    <b-tooltip :label="$t('capacity_gravity_center_tooltip_accessory')"
                               position="is-top">
                      <span class="icon-question-mark"></span>
                    </b-tooltip>
                  </span>
                </div>
              </div>
            </div>

            <div class="result-graph" v-show="false" v-if="1==0 && capacityData.length > 0">
              <template v-if="productDatas.variants.length > 0 && matType === null">
                <p class="no-content">Please select missing options to display data</p>
                <b-loading v-model="isLoading"></b-loading>
              </template>
              <template v-else>
                <label class="y-axis-label">{{ $t('weight') }}</label>
                <line-chart :chart-data="chartData" :options="chartOptions" :height="isPhone ? 300 : 180"></line-chart>
                <label class="x-axis-label">{{ $t('gravity_center') }}</label>
                <b-loading v-model="isLoading"></b-loading>
              </template>
            </div>


            <!-- Footer -->
            <!--            <div class="result-footer">-->
            <!--              <p v-if="!isPhone">Warning : the results given are the result of theoretical calculations. They must be-->
            <!--                validated by a plateform testing.</p>-->
            <!--              <div class="button-container">-->
            <!--                &lt;!&ndash;                            <b-button rounded class="is-primary is-uppercase is-background-color-red" @click="openRapportModal()">-->
            <!--                                                <b-icon size="is-small" icon="pen"></b-icon>-->
            <!--                                                <span>{{ $t('custom_rapport') }}</span>-->
            <!--                                            </b-button>&ndash;&gt;-->
            <!--              </div>-->
            <!--            </div>-->
          </div>

          <p v-if="matType && parseInt(result.machine.height_at_max_capacity) === 0" class="warning-msg">
            {{ $t('capacity_error_message') }}
          </p>
        </div>

      </div>
    </div>
    <div class="content-available-soon" v-else>
      {{ $t('content_available_soon') }}
    </div>
  </main>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import capacityService from '@/services/salesbox/capacity';
import AutocompleteProduct from "@/components/Autocomplete/AutocompleteProduct";
import {Hooper, Slide} from "hooper";
import LineChart from "@/components/Chart/LineChart";
import store from "@/store";
import FilterModal from "@/components/ResearchBlock/machines/FilterModal";
import RapportModal from "@/components/Modal/RapportModal";
import SheetBlockAssociatedDocumentsSelect from "@/components/SheetBlock/SheetBlockAssociatedDocumentsSelect";
import {triggerTrackingEvent} from "@/common/helpers";

export default {
  name: 'MachineCapacityView',
  components: {
    LineChart,
    AutocompleteProduct,
    Hooper,
    Slide
  },
  data() {
    return {
      displayContent: false,
      selectedTab: null,
      isOpen: true,
      machineIsOpen: true,
      matIsOpen: true,
      accessoryIsOpen: false,
      fourcheIsOpen: false,
      capacityData: [],
      capacityDataAttach: [],
      result: [],
      resultAttach: [],
      matType: null,
      engineAttributes: null,
      attachmentAttributes: null,
      forkAttributes: null,
      missingFields: [],
      gravityCenters: [],
      showAttributes: false,
      showAccessory: false,
      selectedAccessory: null,
      accessory: null,
      accessoryBrand: null,
      selectedFork: null,
      forkBrand: null,
      selectedMachineNamePreset: null,
      itemToShow: 3,
      currentSlide: 0,
      chartData: null,
      chartOptions: {
        responsive: true,
        legend: {
          display: false
        },
      },
      isLoading: false,
      visibleAttributes: ['max_lifting_height', 'medium_capacity', 'height_at_max_capacity'],
    }
  },
  computed: {
    ...mapState({
      productDatas: state => state.sheet.productDatas,
      unitType: state => state.settings.unitType,
      isMobile: state => state.settings.isMobile,
      isPhone: state => state.settings.isPhone,
      isTablet: state => state.settings.isTablet,
      isPortrait: state => state.settings.isPortrait,
    }),
    ...mapGetters({
      localeKebabFormat: 'settings/localeKebabFormat'
    }),
    filteredCapacity() {
      return this.capacityData.filter(capacity => this.gravityCenters.includes(capacity[this.unitType].gravity_center))
    },
    filteredCapacityAttach() {
      return this.capacityDataAttach.filter(capacity => this.gravityCenters.includes(capacity[this.unitType].gravity_center))
    },
    missingEngineFields() {
      return this.missingFields.filter(field => field.type === 'machine' && field.required === true)
    },
    missingAttachmentFields() {
      return this.missingFields.filter(field => field.type === 'attachment' && field.required === true)
    },
    missingForkFields() {
      return this.missingFields.filter(field => field.type === 'fork' && field.required === true)
    },
    optionnalEngineFields() {
      return this.missingFields.filter(field => field.type === 'machine' && field.required === false)
    },
    optionnalAttachmentFields() {
      return this.missingFields.filter(field => field.type === 'attachment' && field.required === false)
    },
    optionnalForkFields() {
      return this.missingFields.filter(field => field.type === 'fork' && field.required === false)
    },
    missingFieldsCompleted() {
      let res = true
      this.missingFields.forEach(field => {
        if (this.selectedAccessory) {
          if (field.required === true && this.attachmentAttributes[field.code] === 0) res = false;
        } else {
          if (field.type === 'machine' && field.required === true && field.value === null) res = false;
        }
      })
      return res;
    },
  },
  watch: {
    isTablet: function () {
      this.changeItemToShow();
    },
    isPortrait: function () {
      this.changeItemToShow();
    },
    isPhone: function () {
      this.changeItemToShow();
    },
  },
  created() {
    this.$root.$on('switch-calculator-tab', (code) => {
      this.switchTab(code)
    })
    // this.startLoading();
    this.fetchCapacityData().then(() => {
      this.selectedTab = 'truck_data';
      // this.stopLoading();
      this.displayContent = true
      this.changeItemToShow();
    });
  },
  methods: {
    sendAnalyticsEvent() {
      if (this.matType) triggerTrackingEvent(`calculator_tool`, `${this.productDatas.name || this.productDatas.identifier}`, `${this.matType.name || this.matType.identifier}`)
    },
    getCapacityParams(fields, pdf = false) {
      const formData = new FormData()

      formData.append('machine_identifier', this.productDatas.identifier)
      formData.append('unit', this.$store.state.settings.unitType)

      if (this.matType) {
        formData.append('mast_identifier', this.matType.identifier || this.matType.name)
        if (pdf) formData.append('mast_name', this.matType.name)
      }
      /*const body = {
          machine_identifier: this.productDatas.identifier,
          unit: this.$store.state.settings.unitType
      }*/
      // console.log(fields)
      console.log(this.productDatas)
      if (fields) {
        fields.forEach(field => {
          // body.machine[field.code] = field.value;
          if (field.type === 'machine' && field.value !== null) {
            if (field.code === 'gravity_centers')
              formData.append(`${field.code}`, field.value);
            else formData.append(`machine[${field.code}]`, field.value);
          }
        })
      }
      if (!formData.has('gravity_centers') && this.gravityCenters.length > 0) formData.append('gravity_centers', this.gravityCenters)

      // let accessory = this.hasAccessory
      let attachAttributes = JSON.parse(JSON.stringify(this.attachmentAttributes))
      let fAttributes = JSON.parse(JSON.stringify(this.forkAttributes))

      if (fields) {
        if (this.accessory) {
          formData.append('attachment[brand]', this.accessoryBrand)
          formData.append('attachment[accessory]', this.accessory)
          // formData.append('attachment[attachment_identifier]', this.selectedAccessory.identifier)
        }
        if (this.selectedFork) {
          formData.append('fork[brand]', this.forkBrand)
          formData.append('fork[fork_name]', this.selectedFork)
        }

        fields.forEach(field => {
          if (field.type === 'attachment' && attachAttributes[field.code] !== 0)
            formData.append(`attachment[${field.code}]`, attachAttributes[field.code]);
          else if (field.type === 'fork' && fAttributes[field.code] !== 0)
            formData.append(`fork[${field.code}]`, fAttributes[field.code]);
        })
      }

      return formData
    },
    async fetchCapacityData(fields) {
      this.isLoading = true

      if (fields) {
        let formData = this.getCapacityParams(fields)
        const accessory= fields['accessory'] ? true : false
        await this.getCapacityData(formData, accessory)
      } else {
        const accessory=false
        let formData = this.getCapacityParams()
        await this.getCapacityData(formData, accessory)
      }
    },
    async getCapacityData(formData, withAccessory = false) {
      await capacityService.post(formData).then((res) => {
        const data = res.data.data;

        const machineData = data.machine
        if (machineData) {
          let {missing, missing_optionnal, ...attributes} = machineData
          this.engineAttributes = attributes
        }
        const attachmentData = data.attachment
        if (attachmentData) {
          let {missing, missing_optionnal, ...attributes} = attachmentData
          if (!this.attachmentAttributes || withAccessory) this.attachmentAttributes = attributes
        }
        const forkData = data.fork
        if (forkData) {
          let {missing, missing_optionnal, ...attributes} = forkData
          if (!this.forkAttributes || withAccessory) this.forkAttributes = attributes
        }

        this.missingFields = []

        let units = data.unit[this.$store.state.settings.unitType]
        // console.log(units)

        // fetch missing engine fields
        if (data.machine.missing.length > 0 && this.missingEngineFields.length === 0) {
          data.machine.missing.forEach(field => {
            this.missingFields.push(
                {
                  type: 'machine',
                  code: field,
                  value: null,
                  required: true,
                  unit: (field.includes('_capacity') || field === 'weight') ? units.weight : units.distance
                }
            )
            if (this.engineAttributes[field] !== undefined) delete this.engineAttributes[field]
          })
        }
        if (data.machine.missing_optionnal.length > 0 && this.optionnalEngineFields.length === 0) {
          data.machine.missing_optionnal.forEach(field => {
            this.missingFields.push(
                {
                  type: 'machine',
                  code: field,
                  value: null,
                  required: false,
                  unit: (field.includes('_capacity') || field === 'weight') ? units.weight : units.distance
                }
            )
            if (this.engineAttributes[field] !== undefined) delete this.engineAttributes[field]
          })
        }

        // if refetch with missing fields completed
        if (this.missingEngineFields.length > 0) {
          this.missingEngineFields.forEach(field => {
            if (this.engineAttributes[field.code] !== undefined) delete this.engineAttributes[field.code]
          })
        }
        if (this.optionnalEngineFields.length > 0) {
          this.optionnalEngineFields.forEach(field => {
            if (this.engineAttributes[field.code] !== undefined) delete this.engineAttributes[field.code]
          })
        }

        if (data.attachment) {
          // fetch missing attachment fields if attachment
          if (data.attachment.missing.length > 0 && this.missingAttachmentFields.length === 0) {
            data.attachment.missing.forEach(field => {
              this.missingFields.push(
                  {
                    type: 'attachment',
                    code: field,
                    value: null,
                    required: true,
                    unit: (field.includes('_capacity') || field === 'weight') ? units.weight : units.distance
                  }
              )
            })
          }
          if (data.attachment.missing_optionnal.length > 0 && this.optionnalAttachmentFields.length === 0) {
            data.attachment.missing_optionnal.forEach(field => {
              this.missingFields.push(
                  {
                    type: 'attachment',
                    code: field,
                    value: null,
                    required: false,
                    unit: (field.includes('_capacity') || field === 'weight') ? units.weight : units.distance
                  }
              )
            })
          }
        }

        if (data.fork) {
          // fetch missing fork fields if fork
          if (data.fork.missing.length > 0 && this.missingForkFields.length === 0) {
            data.fork.missing.forEach(field => {
              this.missingFields.push(
                  {
                    type: 'fork',
                    code: field,
                    value: null,
                    required: true,
                    unit: (field.includes('_capacity') || field === 'weight') ? units.weight : units.distance
                  }
              )
            })
          }
          if (data.fork.missing_optionnal.length > 0 && this.optionnalForkFields.length === 0) {
            data.fork.missing_optionnal.forEach(field => {
              this.missingFields.push(
                  {
                    type: 'fork',
                    code: field,
                    value: null,
                    required: false,
                    unit: (field.includes('_capacity') || field === 'weight') ? units.weight : units.distance
                  }
              )
            })
          }
        }

        this.gravityCenters = data.gravity_centers
        if (withAccessory) {
          this.capacityDataAttach = data.residual_capacity
          this.resultAttach = data
        } else {
          this.capacityData = data.residual_capacity
          this.result = data
        }
        this.fillChartData();
        this.isLoading = false
      }).catch((e) => {
        console.error(e)
      })
    },
    refreshCapacityData() {
      this.fetchCapacityData(this.missingFields);
    },
    fillChartData() {
      let mediumData = [];
      let maxData = [];
      let labels = this.gravityCenters;
      this.filteredCapacity.forEach((capacity) => {
        mediumData.push(parseInt(capacity[this.unitType].medium))
        maxData.push(parseInt(capacity[this.unitType].high))
        if (labels.length === 0) labels.push(parseInt(capacity[this.unitType].gravity_center))
      })
      this.chartData = {
        labels,
        datasets: [
          {
            label: this.$t('medium_capacity'),
            borderColor: '#EB1212',
            fill: false,
            pointRadius: 4,
            pointBackgroundColor: this.isPhone ? '#F1F1F1' : '#FFFFFF',
            data: mediumData
          }, {
            label: this.$t('maximum_capacity'),
            borderColor: '#212EFF',
            fill: false,
            pointRadius: 4,
            pointBackgroundColor: this.isPhone ? '#F1F1F1' : '#FFFFFF',
            data: maxData
          }
        ]
      }
    },
    switchTab(code) {
      if (code === 'results' && this.capacityData.length === 0) return
      if (code !== this.selectedTab)
        this.selectedTab = code;
    },
    slidePrev() {
      if (this.canGoPrevious())
        this.$refs['capacity_slider'].slidePrev();
    },
    slideNext() {
      if (this.canGoNext())
        this.$refs['capacity_slider'].slideNext();
    },
    canGoPrevious() {
      return this.currentSlide > 0;
    },
    canGoNext() {
      if (this.capacityData.length > 0) {
        if (this.isPhone) {
          let slideVisible = this.currentSlide * this.itemToShow;
          return ((slideVisible + 1) < this.capacityData.length);
        } else {
          return ((this.currentSlide + 1) < this.capacityData.length);
        }
      }
    },
    changeItemToShow() {
      console.log("window size changed");
      if (this.capacityData.length > 0) {
        if (this.isTablet && !this.isPortrait)
          this.itemToShow = 3;
        else if (this.isPhone && this.isPortrait)
          this.itemToShow = 3;
        else if (this.isPhone && !this.isTablet && !this.isPortrait)
          this.itemToShow = 3;
        else
          this.itemToShow = 4.2;
      }
      //console.log('Portrait :'+this.isPortrait);
      //console.log('Phone :'+this.isPhone);
      //console.log('Tablet :'+this.isTablet);
      //console.log('Items :'+this.itemToShow);
    },
    slideChanged(payload) {
      this.currentSlide = payload.currentSlide;
    },
    changeToInput(index) {
      this.filteredCapacity[index].editable = true
      this.$forceUpdate();
    },
    changeGravityCenter(event, index) {
      const newVal = this.capacityData.filter(data => data[this.unitType].gravity_center === event.target.value)
      if (newVal[0]) {
        this.gravityCenters[index] = parseInt(event.target.value)
      } else {
        // @todo call api with updated gravity center list to fetch new data
        let newGravityCenters = this.gravityCenters
        newGravityCenters[index] = parseInt(event.target.value)
        const fields = {type: 'machine', code: 'gravity_centers', value: newGravityCenters}
        this.isLoading = true;
        this.fetchCapacityData([fields, ...this.missingFields])
        /*this.$toast.open({
            message: this.$t('no_capacity_data_for_this_gravity_center'),
            type: 'is-danger',
            duration: 1500
        })*/
      }
      delete this.filteredCapacity[index].editable
    },
    randomAttachment(event) {
      if (event === 'other') this.selectedAccessory = 'RandomAttachment'
    },
    openRapportModal() {
      this.$buefy.modal.open({
        parent: this,
        component: RapportModal,
        hasModalCard: true,
        fullScreen: this.isPhone,
      })
    },
    getUnit(key) {
      if ((key.indexOf('weight') >-1 ||  key.indexOf('capacity')>-1) && key.indexOf('height')==-1) {
        return this.result.unit[this.unitType].weight
      } else return this.result.unit[this.unitType].distance
    },
    selectModal(capacityPdf = true) {
      this.$buefy.modal.open({
        parent: this,
        component: SheetBlockAssociatedDocumentsSelect,
        hasModalCard: true,
        customClass: 'custom-class custom-class-2',
        trapFocus: true,
        width: 700,
        props: {docType: this.docType, capacityPdf: capacityPdf, postParams: this.getCapacityParams(this.missingFields, true)}
      })

      // triggerTrackingEvent('open_capacity_report_download_modal', 'click', `Ouverture de la popin d'obtention de rapport du calculateur de capacité : ${this.productDatas.name} (${this.productDatas.identifier})`)
    }
  }
}
</script>

<style lang="scss" scoped>
#machine-sheet-capacity {
  //padding-bottom: 40px;

  .buttons {
    position: absolute;
    top: 7%;
    right: 3%;
    z-index: 100;

    @media #{$mq_tablet}  {
      top: 25%;
      right: 36%;
    }

    @media #{$mq_phone}  {
      top: 7%;
      right: 28px;

      & > button {
        width: 42px;
      }

      & > button > span.icon-download {
        margin: 0;
      }

      & > button > span:not(.icon-download) {
        display: none;
      }
    }
  }

  .capacity {
    & > h1 {
      @media #{$mq_tablet} {
        padding: 12px 28px;
      }
    }

    .title {
      margin-bottom: 10px;
    }

    .intro-text {
      @include standard-text-grey;
    }

    .title-arrow {
      float: right;
    }

    .label-item {
      position: relative;
      display: flex;
      margin-bottom: 10px;
      //min-height: 30px;
      font-size: 13px;
      background-image: url('~@/assets/img/spaced-dot.svg');
      background-position: center center;
      background-repeat: repeat-x;
      background-size: 7px 2px;
      width: 100%;

      @media #{$mq_phone} {
        display: block;
        background: none;
        margin-bottom: 10px;

      }

      .the-label {
        display: flex;
        align-items: center;
        background-color: $white;
        font-weight: 500;
        margin-top: 10px;

        @media #{$mq_phone} {
          display: block;
        }

        &.has-drawing-code {
          flex-direction: column;
          justify-content: flex-start;
          margin-top: 6px;
        }

        .label-text {
          padding-bottom: 8px;
          padding-right: 10px;
          text-align: left;
          @media #{$mq_phone} {
            text-align: center;
          }
        }
      }

      .dots {
        flex: 1 1 auto;

        @media #{$mq_phone} {
          display: none;
        }
      }

      .value {
        display: flex;
        align-items: center;
        padding-left: 10px;
        background-color: $white;
        color: $medium-grey;
        text-align: right;

        //@media #{$mq_small_desktop} {
        //    width: 50px;
        //}

        @media #{$mq_phone} {
          display: block;
          width: 100%;
          padding-left: 0;
          margin-top: 5px;
          text-align: center;
        }

        &.is-sorted {
          color: $brand-red;
          font-weight: bold
        }
      }
    }

    .panel-block {

      margin-top: 25px;

      h4 {
        font-weight: 900;
      }
    }

    .pneumatics {
      margin-top: 20px;

      h4 {
        margin-top: 25px;
      }
    }

    .tabs-container {
      max-width: 1920px;
      position: relative;

      @media #{$mq_desktop} {
        .result-tab {
          min-width: 70%;
          width: calc(100% - 380px);
          margin-left: 380px !important;
        }
      }

      @media #{$mq_tablet_min} {
        display: flex;
        justify-content: center;
        align-items: stretch;

        .filter-tab {
          min-width: 320px;
          max-width: 380px;
          flex: 1 0 30%;
          width: 30%;
          position: fixed;
          top: calc(85px + 60px);
          left: 0;
        }

        .result-tab {
          flex: 1 0 70%;
          margin-left: 30%;
          min-height: calc(100vh - 85px - 60px);


          .results {
            position: relative;
            margin-top: 120px;
          }

          h3 {
            font-weight: 900;
          }
        }
      }
    }

    .switcher {
      border-radius: 32px;
      background-color: #F1F1F1;
      margin: 28px auto;
      color: #000000;
      width: min-content;
      max-width: 300px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 8px;

      @media #{$mq_tablet_min} {
        display: none;
      }

      .switcher-tab {
        font-size: 13px;
        font-weight: bold;
        letter-spacing: 0.9px;
        line-height: 15px;
        text-align: center;
        padding: 8px 14px;
        text-transform: uppercase;
        opacity: 0.7;
        white-space: nowrap;

        &.selected {
          border-radius: 24px;
          background-color: $brand-red;
          color: #FFFFFF;
          opacity: 1;
        }

        &.disabled {
          opacity: 0.3;
        }
      }
    }

    .filter-tab {
      display: flex;
      flex-direction: column;
      padding: 12px 28px;

      @media #{$mq_phone_min} {
        padding-top: 35px;
        flex-direction: row;
        flex-wrap: wrap;

        &-header, &-footer {
          flex: 1 0 100%;
        }

        &-product, &-attachment {
          flex: 1 0 50%;
        }

        &-attachment {
          padding-top: 44px;
          padding-left: 20px;
        }
      }

      @media #{$mq_tablet_min} {
        flex-direction: column;
        flex-wrap: nowrap;
        max-height: calc(100vh - 85px - 60px);
        overflow-y: scroll;
        padding-bottom: 80px;

        &-header, &-footer, &-product, &-attachment {
          flex: 1 0 auto;
          padding: 0;
        }

        &-footer {
          max-width: 375px;
          width: 30%;
          position: fixed;
          bottom: 0;
          left: 0;
          padding: 20px 0;
          background-color: #fff;
        }

        /* width */
        &::-webkit-scrollbar {
          width: 5px;
          height: 5px;
        }

        /* Track */
        &::-webkit-scrollbar-track {
          background: #F1F1F1;
        }

        /* Handle */
        &::-webkit-scrollbar-thumb {
          border-radius: 5px;
          background: #888;
        }

        /* Handle on hover */
        &::-webkit-scrollbar-thumb:hover {
          background: #C1C1C1;
        }
      }

      &-footer {
        text-align: center;
      }

      h1 {
        margin-bottom: 34px;
      }

      .image-container {
        height: 0;
        padding-bottom: 100%;
        border-radius: 20px;
        background-color: #f1f1f1;
        //background: url('~@/assets/img/dimensions-diagrams/2.jpg'), #f1f1f1;
        background-size: contain;
      }

      hr.group-separator {
        background-color: $light-grey;
      }

      img {
        width: 100%;
        margin: 18px 0 14px;
      }

      .select-container {
        /deep/ .colored-label {
          font-size: 17px !important;
        }

        /deep/ .select, /deep/ select, /deep/ .input, /deep/ input {
          width: 100%;
          font-size: 16px !important;
        }
      }

      .select-container, .missing-fields, .missing-optionnal {
        /deep/ .colored-label {
          //@include small-title($black);
          color: #363636;
          font-size: 14px;
          font-weight: 900;
          text-transform: uppercase;
        }

        /deep/ .select, /deep/ select, /deep/ .input, /deep/ input {
          width: 100%;
          font-size: 13px;
        }
      }

      .product-accessory {
        margin: 24px 0 14px;
        border-radius: 20px;
        transition: ease-in .3s;

        .toggle-details, .toggle-accessory {
          overflow: hidden;

          .toggle-title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            text-transform: uppercase;
          }

          .accessory-details {
            font-weight: normal;
            color: #000000;
            font-family: $font_roboto;
            font-size: 15px;
            letter-spacing: 0;
            line-height: 20px;
            text-transform: none;

            span {
              color: #919191;
              font-family: $font_roboto;
              font-size: 15px;
              letter-spacing: 0;
              line-height: 20px;
            }
          }

          .button.link {
            border: none;
            background: none;
            color: #101010;
            font-family: $font_roboto;
            font-size: 13px;
            font-weight: bold;
            letter-spacing: 0.9px;
            line-height: 15px;
            text-transform: uppercase;

            &:hover /deep/ span:not(.icon) {
              text-decoration: underline;
            }
          }

          hr {
            border: 1px dashed #979797;
            opacity: 0.5;
            margin: 20px auto;
            transform: scale(1.1);
          }

          .icon-close {
            font-size: 18px;
            padding: 3px;
          }

          p {
            font-weight: bold;
          }
        }

        /*.attributes {
            margin-bottom: -12px!important;
        }*/

        .missing-fields, .missing-optionnal {
          /deep/ input {
            background-color: #f1f1f1;
          }
        }

        .accessory-input {
          background-color: grey;
        }

        .attributes, .accessory-select {
          margin: 10px 0;

          li {
            margin-bottom: 18px;

            &:last-of-type {
              margin-bottom: 0;
            }
          }

          label {
            color: $brand-red;
            font-size: 15px;
            letter-spacing: 0;
            line-height: 20px;
          }

          p {
            margin-top: 8px;
          }

          .radio-container {
            margin: 8px 0 22px;

            /deep/ .b-radio.radio {
              margin-right: 10px;

              input[type=radio]:checked + .check:before {
                transform: scale(0.6);
              }

              .check {
                border: none;
                background: #fff;
              }

              .control-label {
                margin-left: 4px;
                color: $black;
              }
            }
          }

          /deep/ .autocomplete .input {
            background: #f1f1f1;
          }
        }
      }
    }

    .info-select-mat {
      background-color: #101010;
      padding: 18px;
      display: inline-block;
      border-radius: 10px;
      margin-top: 20px;
      margin-left: 25%;

      @media #{$mq_phone} {
        margin-top: 15px;
        margin-bottom: 15px;
        margin-left: 10%;
        margin-right: 10%;
      }
    }

    .button-share {
      border-left: solid 2px #ffffff;
    }

    .text-select-mat {
      color: white;
      display: flex;
      align-items: center;

      .icon {
        margin-right: 10px;
      }
    }

    .result-tab {
      background-color: $white;
      padding: 12px 28px;

      @media #{$mq_phone} {
        min-height: calc(100vh - 120px);
        padding: 12px 0;

        .result-slider {
          padding: 8px 20px 20px!important;
        }
        .result-graph {
          background-color: #F1F1F1 !important;
          width: calc(100% - 10px * 2);
          margin: auto;
        }

        .title, .introduction-text {
          margin-left: 28px;
          margin-right: 28px;
        }
      }

      @media #{$mq_phone_min} {
        padding: 18px 30px 18px 20px;
        background-color: #F1F1F1;
      }

      .result-title {
        @media #{$mq_tablet} {
          margin-top: 50px;
        }
        @media #{$mq_phone} {
          margin-top: 0;
        }
      }

      .result-container {
        margin-top: 30px;

        &.hidden {
          display: none;
        }

        h3 {
          padding: 12px;
        }
      }

      .warning-msg {
        margin-top: 24px;
      }

      .result-slider {
        //margin-top: 20px;

        //@media #{$mq_phone} {
        //  margin-top: 40px;
        //}
      }

      .result-slider, .result-graph {
        border-radius: 20px;
        padding: 12px;
        margin-bottom: 10px;
      }

      .info-tooltip-mobile {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;

        .icon-question-mark {
          padding: 6px;
          //border: solid 1px;
          margin-right: 8px;
          border-radius: 100%;
          font-size: 0.6em;
          background: grey;
          color: white;
        }
      }

      .capacity-comparison-container {
        position: relative;
        width: 100%;

        & > .label-text {
          margin-left: calc(30% + 70px);
          display: flex;

          @media #{$mq_phone} {
            & > label {
              position: absolute;
              bottom: 66px;
              left: calc(50% + 12px);
              transform: translateX(-50%);
              width: calc(100% - 48px);
              line-height: 18px;
              font-size: 12px;
              font-weight: 400;
              text-align: center;
              padding: 4px 0;
              background: #fff;
              color: #818181;
            }

            .b-tooltip {
              display: none;
            }
          }
        }

        & .b-tooltip {
          margin-top: -6px;
        }

        .icon-question-mark {
          padding: 6px;
          //border: solid 1px;
          margin-left: 8px;
          border-radius: 100%;
          font-size: 0.6em;
          background: grey;
          color: white;
        }

        .nothing-selected {
          min-height: 52px;
        }
      }

      .capacity-comparison {
        display: flex;
        align-items: stretch;
        text-align: left;
        overflow: hidden;
        margin-bottom: 10px;

        @media #{$mq_phone} {
          //flex-wrap: wrap;
          //padding-top: 40px;
          //margin-top: -40px;
        }

        &:first-child {
          .slider-column {
            .mobile-slider-controls {
              top: -30px;
            }
          }
        }

        .label-column {
          flex: 0 0 30%;
          margin-right: 70px;

          @media #{$mq_phone} {
            flex: 0 0 40%;
            max-width: 40%;
            margin-right: 20px;
            //margin-left: -20px;
          }

          .label-column-wrap {
            position: relative;

            @media #{$mq_phone} {
              height: 100%;
            }

            label {
              padding: 8px 0;
              top: -40px;
            }

            & > div {
              margin-right: 10px;

              @media #{$mq_phone} {
                margin-bottom: 20px;
              }

              &:first-of-type {
                strong {
                  border-top-left-radius: 10px;
                  border-top-right-radius: 10px;
                }
              }

              &:last-of-type {
                strong {
                  border-bottom-left-radius: 10px;
                  border-bottom-right-radius: 10px;
                }

                label {
                  bottom: -40px;
                }
              }

              strong {
                font-size: 15px;
                font-weight: bold;
                letter-spacing: 0;
                line-height: 36px;
                white-space: nowrap;

                /* New design */
                border: 1px solid #BABABA;
                width: 75px;
                background: white;
                display: flex;
                padding: 8px 0;
                justify-content: center;

                @media #{$mq_phone} {
                  white-space: normal;
                  width: 100%;
                }
              }

              label {
                max-width: 60%;
                white-space: normal;

                @media #{$mq_phone} {
                  //display: none;
                  position: absolute;
                  max-width: unset;
                  width: 140px;
                  z-index: 1;
                }
              }

              span {
                font-size: 15px;
                letter-spacing: 0;
                line-height: 20px;
                display: flex;
                //align-items: center;
                justify-content: space-between;
                white-space: nowrap;

                @media #{$mq_phone} {
                  position: relative;
                  line-height: initial;
                  white-space: normal;
                }
              }
            }
          }
        }
        .slider-column {
          position: relative;
          flex: 1 1 auto;
          display: flex;

          &.attachment-slider:before {
            content: '';
            position: absolute;
            bottom: 90px;
            left: -75px;
            width: 20px;
            height: 130px;
            background-size: auto 100%;
            background: #818181 url("~@/assets/img/accessory_base.svg") no-repeat center;
            border: 1px solid #595959;

            @media #{$mq_phone} {
              display: none;
            }
          }

          @media #{$mq_phone} {
            //max-width: 60%;
            padding-left: 24px;
          }

          .mobile-slider-controls {
            display: none;
            position: absolute;
            top: 0;
            left: 0;
            width: calc(100vw - 170px);
            z-index: 5;

            @media #{$mq_phone} {
              display: block;
            }

            .action {
              opacity: 0.2;
              cursor: pointer;


              &:after {
                @include icomoon;
                content: "\e918";
                display: inline-block;
                font-size: 22px;
                color: $blackish;
                transition: color 0.3s ease;
              }

              &.available {
                opacity: 1;
              }

              &.previous {
                float: left;

                &:after {
                  transform: rotate(90deg);
                }
              }

              &.next {
                float: right;
                margin-right: 25px;

                &:after {
                  transform: rotate(-90deg);
                }
              }
            }
          }


          .hooper {
            height: auto;
            max-width: 310px;

            &:before {
              content: '';
              position: absolute;
              bottom: 90px;
              left: -50px;
              width: 20px;
              height: 130px;
              background-color: #A5A5A5;
            }

            &:after {
              content: '';
              position: absolute;
              bottom: 70px;
              left: -50px;
              width: 100%;
              height: 20px;
              background-image: url("~@/assets/img/fork_base.svg");
              background-repeat: no-repeat;
              background-size: contain;

              @media #{$mq_phone} {
                background-size: cover;
              }
            }

            @media #{$mq_phone} {
              height: 100%;
              max-width: 100%;

              &:before {
                left: -25px;
                top: 0;
                height: calc(100% - 124px);
              }

              &:after {
                left: -25px;
                width: calc(100% + 28px);
                bottom: 104px;
              }
            }

            .hooper-slide {
              height: auto;
              text-align: center;
              display: flex;
              flex-direction: column;
              justify-content: space-between;

              &:first-of-type {
                .capacity-slide-box > p:first-of-type {
                  border-top-left-radius: 10px;
                }

                .capacity-slide-box > p:last-of-type {
                  border-bottom-left-radius: 10px;
                }

                & > strong {
                  border-top-left-radius: 10px;
                  border-bottom-left-radius: 10px;
                }
              }

              &:last-of-type {
                .capacity-slide-box > p:first-of-type {
                  border-top-right-radius: 10px;
                }

                .capacity-slide-box > p:last-of-type {
                  border-bottom-right-radius: 10px;
                }

                & > .field, .field /deep/ input {
                  border-top-right-radius: 10px;
                  border-bottom-right-radius: 10px;
                }
              }

              /deep/ .field {
                margin-left: auto;
                margin-right: auto;

                input {
                  background-color: #fff;
                  height: 54px;
                  text-align: center;
                  font-weight: 700;

                  //&:focus {
                  //  border-color: $brand-red;
                  //}

                  @media #{$mq_phone} {
                    height: calc(52px + 30px);
                    padding-top: 28px;
                    padding-bottom: 0;
                  }
                }

                /*.input {
                  border: 2px solid #979797;
                  border-radius: 26.5px;
                  background-color: #F1F1F1;
                }

                .icon {
                  font-size: 12px;
                  top: 50%;
                  transform: translate(5px, -50%);
                }*/
              }

              strong {
                @media #{$mq_phone} {
                  padding-top: 28px;
                }
              }

              strong, /deep/ .field {
                line-height: 54px;
                display: flex;
                align-items: flex-end;
                justify-content: center;

                /* New design */
                border: 1px solid #BABABA;
                background: white;
                //padding: 6px 0;
                font-weight: 700;
                overflow: hidden;

                @media #{$mq_phone} {
                  margin-top: 52px;
                }

                .button {
                  border: none;
                  margin-left: 10px;
                }
              }

              .gravity-input {
                border: solid 2px #EB1212;
              }

              .capacity-slide {
                height: 160px;
              }

              .capacity-slide-box {
                border-radius: 20px;
                background-color: #F1F1F1;
                position: relative;

                /*
                * OLD DESIGN

                &:before {
                  content: '';
                  width: 5px;
                  height: 3px;
                  position: absolute;
                  left: -5px;
                  top: 26px;
                  background-color: $brand-red;
                }

                &:after {
                  content: '';
                  width: 5px;
                  height: 3px;
                  position: absolute;
                  left: -5px;
                  bottom: 34px;
                  background-color: $vivid-blue;
                }*/

                p {
                  border: 1px solid #BABABA;
                  /* border-radius: 10px; */
                  //width: 75px;
                  background: white;
                  display: flex;
                  padding: 8px 0;
                  justify-content: center;
                  font-weight: 700;
                  line-height: 36px;

                  @media #{$mq_phone} {
                    //margin-bottom: 20px;
                    padding-top: 36px;
                  }
                }
              }
            }

            /*
            * OLD DESIGN

            &:before {
              content: '';
              width: 20px;
              height: 3px;
              position: absolute;
              left: -20px;
              bottom: 83px;
              display: none;
              background-color: $brand-red;

              @media #{$mq_phone} {
                top: calc(60px + 24px + 14px);
              }
            }

            &:after {
              display: none;
              content: '';
              width: 20px;
              height: 3px;
              position: absolute;
              left: -20px;
              bottom: 34px;
              background-color: $vivid-blue;
            }*/
          }

          .hooper-label {
            display: none;
            margin-left: -50px;

            @media #{$mq_phone} {
              display: block;
              position: absolute;
              width: calc(100% - 48px);
              top: 1px;
              left: calc(50% + 12px);
              transform: translateX(-50%);
              text-align: center;
              margin-left: 0;

              & > div {
                margin-bottom: 46px;
                background: #fff;

                p {
                  color: #818181;
                }
              }
            }

            .label-text {
              line-height: 54px;

              @media #{$mq_phone} {
                line-height: 18px;
                font-size: 12px;
                font-weight: 400;
              }
            }
          }

          /*
          * OLD DESIGN
          &:before {
            content: '';
            height: 13px;
            width: 13px;
            z-index: 1;
            position: absolute;
            left: -33px;
            top: 83px;
            display: none;
            border: 3px solid $brand-red;
            border-radius: 50%;
            background-color: $white;

            @media #{$mq_phone} {
              left: -20px;
              top: calc(60px + 24px + 8px);
            }
          }

          &:after {
            content: '';
            height: 13px;
            width: 13px;
            z-index: 1;
            position: absolute;
            left: -33px;
            bottom: 60px;
            display: none;
            border: 3px solid $vivid-blue;
            border-radius: 50%;
            background-color: $white;

            @media #{$mq_phone} {
              left: -20px;
              bottom: 30px;
            }
          }*/
        }
      }

      .result-graph {
        padding: 12px 34px 34px 34px;
        position: relative;
        min-height: 300px;

        @media #{$mq_phone} {
          padding-right: 12px;
          min-height: 200px;
        }

        p.no-content {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-family: $font_roboto;
          opacity: 0.5;
          font-size: 14px;
          font-weight: bold;
          letter-spacing: 0.97px;
          line-height: 16px;
        }

        label {
          color: #7D7D7D;
          font-family: $font_roboto;
          opacity: 0.5;
          font-size: 14px;
          font-weight: bold;
          letter-spacing: 0.97px;
          line-height: 16px;
          text-transform: uppercase;
          position: absolute;

          &.x-axis-label {
            right: 34px;

            @media #{$mq_phone} {
              right: 12px;
            }
          }

          &.y-axis-label {
            left: 18px;
            top: 60px;
            transform: translateX(-50%) rotate(-90deg);
          }
        }
      }

      .result-footer {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        flex-wrap: wrap;
        margin-top: 20px;

        @media #{$mq_phone_min} {
          flex-wrap: nowrap;
        }

        p, .button-container {
          flex: 1 0 50%;
        }

        .button-container {
          display: flex;
          justify-content: center;
          margin-top: 12px;

          @media #{$mq_phone_min} {
            margin-top: 0;
            justify-content: flex-end;
          }

          .button {
            /deep/ .icon {
              font-size: 12px;
              margin-right: 18px;
            }
          }
        }
      }
    }

    h1 {
      @include large-title($black);
    }


    h2 {
      @include large-title($brand-red);
    }
  }
}
</style>
